module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "introduction"
  }, [_c('img', {
    staticClass: "introduction__image",
    attrs: {
      "src": require("./../assets/profile.jpg"),
      "alt": "profile"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "introduction__content"
  }, [_c('strong', [_vm._v("I")]), _vm._v("am a Japanese software engineer / tech geek / history nerd / future astronaut. As I grew up in multiple communities in multiple cities (7 cities in 3 countries, to be exact!), I realized that this world is one huge Cultural Mosaic. Billions of people have Billions of different stories behind. Now, it's time to write the story of my life."), _c('br'), _c('br'), _vm._v("What does your story look like? "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scroll()
      }
    }
  }, [_vm._v("Share them with me!")]), _vm._v(" I'm always looking for a key to open the next door.\n    ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "profile__header about__header"
  }, [_vm._v("PROFILE")]), _vm._v(" "), _c('div', {
    staticClass: "profile__label"
  }, [_vm._v("Date of Birth:")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("21/10/1992")]), _vm._v(" "), _c('div', {
    staticClass: "profile__label"
  }, [_vm._v("Sex:")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Male")]), _vm._v(" "), _c('div', {
    staticClass: "profile__label"
  }, [_vm._v("Belief:")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Christian (Baptist)")]), _vm._v(" "), _c('div', {
    staticClass: "profile__label"
  }, [_vm._v("Location:")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Sapporo, Hokkaido, Japan")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Asahikawa, Hokkaido, Japan")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Munich, Germany")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Tokyo, Japan")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Kushiro, Hokkaido, Japan")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Columbus, Ohio, USA")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Kyoto, Japan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "skills"
  }, [_c('div', {
    staticClass: "skills__header about__header"
  }, [_vm._v("SKILLS")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Ruby")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Ruby on Rails")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Firebase")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Heroku")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("PHP")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Wordpress")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Perl")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Python")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("ES8")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("React")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Vue.js")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("MySQL")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("PostgreSQL")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Docker")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Hadoop")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Linux")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Git")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("HTML5")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("CSS3")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("jQuery")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Google Apps Script")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links",
    attrs: {
      "id": "links"
    }
  }, [_c('div', {
    staticClass: "links__header about__header"
  }, [_vm._v("LINKS")]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "https://github.com/andoshin11",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "https://www.linkedin.com/in/shin-ando-95193972/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin-square",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "https://www.instagram.com/andoshin11/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "https://twitter.com/andoshin11",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "https://www.facebook.com/andoshin11",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook-official",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "http://www.justyo.co/ANDOSHIN11/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-square",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "mailto:shinglish11@gmail.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "https://www.amazon.co.jp/gp/registry/wishlist/1GOD9AV7NRYPZ/ref=nav_wishlist_lists_1",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-amazon",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53f92474"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 23
// module chunks = 0